/**
 * Deterministic date formatters — used everywhere a date is rendered in
 * SSR'd content. The Workers runtime ships a limited ICU build, so
 * `toLocaleDateString("en-GB", { month: "long" })` returns different
 * strings server vs browser → React hydration error #418.
 * These helpers produce identical output in both environments.
 */
const MONTHS_LONG = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
const MONTHS_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

function parse(input: string | Date): Date {
  return input instanceof Date ? input : new Date(input);
}

/** "21 June 2026" */
export function formatDateLong(input: string | Date): string {
  const d = parse(input);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getUTCDate()} ${MONTHS_LONG[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

/** "Jun 2026" */
export function formatMonthYearShort(input: string | Date): string {
  const d = parse(input);
  if (Number.isNaN(d.getTime())) return "";
  return `${MONTHS_SHORT[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}
